/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Oauth_Client_ExistsInputs */

const en_error_oauth_client_exists = /** @type {(inputs: Error_Oauth_Client_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This client is admitted already.`)
};

/**
* | output |
* | --- |
* | "This client is admitted already." |
*
* @param {Error_Oauth_Client_ExistsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_oauth_client_exists = /** @type {((inputs?: Error_Oauth_Client_ExistsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Oauth_Client_ExistsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_oauth_client_exists(inputs)
});